import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';

const NAV_LINKS = [
  { to: '/features',            label: 'Features' },
  { to: '/pricing',             label: 'Pricing' },
  { to: '/workforce-management',label: 'Workforce Mgmt' },
  { to: '/blog',                label: 'Blog' },
  { to: '/contact',             label: 'Contact' },
];

export function MarketingHeader() {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);

  return (
    <header className="bg-white border-b border-slate-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2 shrink-0">
          <div className="w-9 h-9 bg-orange-500 rounded-lg flex items-center justify-center shadow-sm shadow-orange-200">
            <span className="text-white font-bold text-sm">RS</span>
          </div>
          <span className="font-bold text-lg text-slate-900" style={{ fontFamily: 'Manrope' }}>ReStaff</span>
        </Link>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-6">
          {NAV_LINKS.map(({ to, label }) => (
            <Link
              key={to}
              to={to}
              className={`text-sm font-medium transition-colors ${
                pathname === to ? 'text-orange-600' : 'text-slate-600 hover:text-slate-900'
              }`}
            >
              {label}
            </Link>
          ))}
        </nav>

        {/* Desktop CTA */}
        <div className="hidden md:flex items-center gap-2">
          <Link to="/login">
            <Button variant="ghost" size="sm" className="text-slate-600">Login</Button>
          </Link>
          <Link to="/register">
            <Button size="sm" className="bg-orange-500 hover:bg-orange-600 text-white">
              Start Free Trial
            </Button>
          </Link>
        </div>

        {/* Mobile toggle */}
        <button
          className="md:hidden p-2 rounded-md text-slate-600 hover:bg-slate-100"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="md:hidden border-t border-slate-100 bg-white px-4 py-4 space-y-3">
          {NAV_LINKS.map(({ to, label }) => (
            <Link
              key={to}
              to={to}
              className="block text-sm font-medium text-slate-700 py-1 hover:text-orange-600"
              onClick={() => setOpen(false)}
            >
              {label}
            </Link>
          ))}
          <div className="pt-2 flex gap-2">
            <Link to="/login" className="flex-1" onClick={() => setOpen(false)}>
              <Button variant="outline" size="sm" className="w-full">Login</Button>
            </Link>
            <Link to="/register" className="flex-1" onClick={() => setOpen(false)}>
              <Button size="sm" className="w-full bg-orange-500 hover:bg-orange-600 text-white">Free Trial</Button>
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
